import { enStrings, TranslationKey } from './en';
import { arStrings } from './ar';
import { isRTLLocale } from '../utils/rtl';

type Translator = (key: TranslationKey, params?: Record<string, string | number>) => string;

function interpolate(template: string, params: Record<string, string | number>): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, k) => String(params[k] ?? ''));
}

export function createTranslator(locale: string): Translator {
  const strings = isRTLLocale(locale) ? arStrings : {};
  return (key: TranslationKey, params?: Record<string, string | number>): string => {
    const template =
      (strings as Record<string, string>)[key] ??
      (enStrings as Record<string, string>)[key] ??
      key;
    if (!params) return template;
    return interpolate(template, params);
  };
}

export type { TranslationKey };
